import React from 'react';
import styled from 'styled-components';

import MaterialIcon from '@/components/atom/MaterialIcon';
import theme from '@/styles/theme';

interface Props {
  title: string;
  description: string;
  onClickWriteReview: () => void;
}
const AnswerWriteReview = ({
  title,
  description,
  onClickWriteReview,
}: Props) => {
  return (
    <Wrapper>
      <InnerTopWrapper>
        <IconWrapper>
          <MaterialIcon
            name={'reviews'}
            size={16}
            color={theme.color.primary700}
          />
        </IconWrapper>
        <TopTextWrapper>
          <TopTitle>{title}</TopTitle>
          <TopDescription>{description}</TopDescription>
        </TopTextWrapper>
      </InnerTopWrapper>
      <WriteReviewButton onClick={onClickWriteReview}>
        리뷰 쓰기
      </WriteReviewButton>
    </Wrapper>
  );
};

export default AnswerWriteReview;

const Wrapper = styled.div`
  margin-top: 20px;
  padding: 16px;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.color.gray30};
`;

const InnerTopWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  margin-bottom: 8px;
  gap: 8px;
`;

const TopTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const TopTitle = styled.h4`
  ${({ theme }) => theme.typography.UI14SB}
  color: ${({ theme }) => theme.color.primary700};
`;

const TopDescription = styled.p`
  ${({ theme }) => theme.typography.UI14M}
  color: ${({ theme }) => theme.color.gray500};
`;

const IconWrapper = styled.div`
  width: 16px;
  height: 20px;
  display: flex;
  align-items: center;
`;

const WriteReviewButton = styled.button`
  ${({ theme }) => theme.typography.UI14SB}
  color: ${({ theme }) => theme.color.white};
  background-color: ${({ theme }) => theme.color.primary600};
  border: none;
  padding: 0 16px;
  border-radius: 8px;
  cursor: pointer;
  width: 100%;
  text-align: center;
  height: 40px;
`;
